import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const allLogsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.allLogsMainTableData',
        popover: {
          title: 'Logs Overview',
          description:
            'This table provides a comprehensive view of all system logs. Use it to monitor, filter, and analyze logs for better system management and troubleshooting.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default allLogsDriverObj;
